import { render, staticRenderFns } from "./Foods.vue?vue&type=template&id=437bb494&scoped=true&"
import script from "./Foods.vue?vue&type=script&lang=js&"
export * from "./Foods.vue?vue&type=script&lang=js&"
import style0 from "./Foods.vue?vue&type=style&index=0&id=437bb494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437bb494",
  null
  
)

export default component.exports